import React, { useEffect } from "react";
import "../css/style.css";

function ContactIntro() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="contact-intro-section">
      <div className="container text-center">
        <p className="contact-intro-text fade-up">
          <strong>We’re Here to Help</strong> 
       At NeatNest, we believe easy communication is the first step toward exceptional service. Whether you have a question, need a custom cleaning plan, or want to book a service, our team is always ready to assist you. We make it simple and convenient to connect with us for all your home cleaning needs.

Reach out to our friendly support team for quick responses, clear guidance, and reliable assistance. From service inquiries and scheduling to feedback and support, we ensure a smooth and hassle-free experience. At NeatNest, your comfort and satisfaction matter to us, and we’re always just a message or call away to help keep your home clean, fresh, and stress-free.
    </p>
      </div>
    </section>
  );
}

export default ContactIntro;
